import { render, staticRenderFns } from "./SettingsProfile.vue?vue&type=template&id=1c7dd89b&scoped=true"
import script from "./SettingsProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsProfile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsProfile.vue?vue&type=style&index=0&id=1c7dd89b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7dd89b",
  null
  
)

export default component.exports